var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Icon as UIIcon, CountryList } from "../UI";

function getFaSize(size) {
  switch (size) {
    case 'xs':
      return 'sm';
    case 'sm':
      return 'lg';
    case 'md':
      return '2x';
    case 'lg':
      return '2x';
    case 'xlg':
      return '2x';
    default:
      return 'sm';}

}

export class Icon extends Component {
  getJSData() {
    const { data } = this.props;
    let _data = data;

    if (data && _data.toJS) {
      _data = _data.toJS();
    }

    return _data;
  }

  getIcon(_data) {
    const { className, size } = this.props;
    let icon;

    if (_data.type === 'Icons') {
      icon = /*#__PURE__*/_jsx(UIIcon, { icon: `${_data._id}`, size: `${getFaSize(size)}` });
    }

    if (_data.type === 'Flags') {
      const flagClassName = `flag-icon flag-icon-${CountryList.get(_data._id).cca2}`.toLowerCase();
      const componentClassName = `${className} ${flagClassName}`;
      icon = /*#__PURE__*/_jsx("span", { className: componentClassName });
    }

    return icon;
  }

  render() {
    const { className } = this.props;
    let html = null;
    const _data = this.getJSData();

    if (_data && _data._id) {
      const icon = this.getIcon(_data);
      html = /*#__PURE__*/_jsx("span", { className: className }, void 0, icon);
    }

    return html;
  }
}

Icon.defaultProps = {
  data: undefined,
  className: undefined,
  size: undefined
};







export default connect()(Icon);